// extracted by mini-css-extract-plugin
export default {"cls1":"SearchUpsell-cls1__d24ffded5fef55e77a8a","cls2":"SearchUpsell-cls2___d892d19e711a299b657 SearchUpsell-cls1__d24ffded5fef55e77a8a"};